import { SearchQuery } from "../code/search-query/search-query";
import ManagedGridView from "../controls/ManagedGridView";
import { getBadges } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import {
  badgesViewColumns,
  mapBadgesViewQuery,
  badgesSearchSchema,
} from "./BadgesView.default";

export interface BadgesViewProps {
  readonly trigger?: string;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

// Read-only: badges are seed/dev-registered (the backend BadgesController is search-only).
function BadgesView(props: BadgesViewProps) {
  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={badgesViewColumns}
      schema={badgesSearchSchema}
      mapQuery={mapBadgesViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getBadges, { retry: true })}
      pageSize={100}
    />
  );
}

export default BadgesView;
